import { useMutation } from "@apollo/client";
import {
    DeleteApplicationDocument,
    DeleteApplicationMainDocument,
    DeleteApplicationMainModelDocument,
    DeleteApplicationMainModelMutation,
    DeleteApplicationMainMutation,
    DeleteApplicationMutation,
    DeleteMobileNotificationDocument,
    DeleteMobileNotificationMutation
} from "../../../generated/graphql";

export const useDeleteApp = (id: string) => {
    const [
        deleteApp,
        {data: deleteAppData, loading: deleteAppLoading, error: deleteAppError},
    ] = useMutation<DeleteApplicationMutation>(DeleteApplicationDocument, {
        variables: { id },
    });

    return {
        deleteApp,
        deleteAppData,
        deleteAppLoading,
        deleteAppError,
    };
};

export const useDeletePage = (id: string) => {
    const [
        deletePage,
        {
            data: deletePageData,
            loading: deletePageLoading,
            error: deletePageError,
        },
    ] = useMutation<DeleteApplicationMainMutation>(
        DeleteApplicationMainDocument,
        {
            variables: { id },
        }
    );
    return {
        deletePage,
        deletePageData,
        deletePageLoading,
        deletePageError,
    };
};

export const useDeleteModel = (id: string) => {
    const [
        deleteModel,
        {
            data: deleteModelData,
            loading: deleteModelLoading,
            error: deleteModelError,
        },
    ] = useMutation<DeleteApplicationMainModelMutation>(
        DeleteApplicationMainModelDocument,
        { variables: { id } }
    );

    return {
        deleteModel,
        deleteModelData,
        deleteModelLoading,
        deleteModelError
    };
};

export const useDeleteNotification = (id: string) => { 
    const [
        deleteNotification,
        {
        data: deleteNotificationData,
        loading: deleteNotificationLoading,
        error: deleteNotificationError,
        },
    ] = useMutation<DeleteMobileNotificationMutation>(
        DeleteMobileNotificationDocument,
    {
        variables: { id },
    }
        );
    
    return {
        deleteNotification,
        deleteNotificationData,
        deleteNotificationLoading,
        deleteNotificationError,
    };
};